import VyjadreniaPredbeznaInformaciaPage from './VyjadreniaPredbeznaInformaciaPage';

export default VyjadreniaPredbeznaInformaciaPage;
